import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The `AWSDate` scalar type provided by AWS AppSync, represents a valid ***extended*** [ISO 8601 Date](https://en.wikipedia.org/wiki/ISO_8601#Calendar_dates) string. In other words, this scalar type accepts date strings of the form `YYYY-MM-DD`.  The scalar can also accept "negative years" of the form `-YYYY` which correspond to years before `0000`. For example, "**-2017-05-01**" and "**-9999-01-01**" are both valid dates.  This scalar type can also accept an optional [time zone offset](https://en.wikipedia.org/wiki/ISO_8601#Time_zone_designators). For example, "**1970-01-01**", "**1970-01-01Z**", "**1970-01-01-07:00**" and "**1970-01-01+05:30**" are all valid dates. The time zone offset must either be `Z` (representing the UTC time zone) or be in the format `±hh:mm:ss`. The seconds field in the timezone offset will be considered valid even though it is not part of the ISO 8601 standard. */
  AWSDate: any;
};











export type Campaign = {
  __typename?: 'Campaign';
  id: Scalars['ID'];
  client: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  storeContext: Scalars['String'];
  itemContext: Scalars['String'];
  name: Scalars['String'];
  storeGroupName: Scalars['String'];
  storeGroupId?: Maybe<Scalars['String']>;
  itemGroupName: Scalars['String'];
  itemGroupId?: Maybe<Scalars['String']>;
  objective: Objective;
  notes?: Maybe<Scalars['String']>;
  startDate: Scalars['AWSDate'];
  endDate?: Maybe<Scalars['AWSDate']>;
  archivedDate?: Maybe<Scalars['AWSDate']>;
  archived: Scalars['Boolean'];
  status: Status;
  storeFilters?: Maybe<CampaignFilter>;
  itemFilters?: Maybe<CampaignFilter>;
  createdOn?: Maybe<Scalars['AWSDate']>;
  lastEdited?: Maybe<Scalars['AWSDate']>;
  deleted?: Maybe<Scalars['Boolean']>;
};

export type CampaignFilter = {
  __typename?: 'CampaignFilter';
  accounts?: Maybe<Array<Maybe<Scalars['String']>>>;
  stores?: Maybe<Array<Maybe<Scalars['String']>>>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
  counts?: Maybe<CampaignFilterCount>;
};

export type CampaignFilterCount = {
  __typename?: 'CampaignFilterCount';
  accounts: Scalars['Int'];
  stores: Scalars['Int'];
  items: Scalars['Int'];
};

export type CampaignFilterInput = {
  accounts?: Maybe<Array<Maybe<Scalars['String']>>>;
  stores?: Maybe<Array<Maybe<Scalars['String']>>>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  items?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CampaignList = {
  __typename?: 'CampaignList';
  data: Array<Maybe<Campaign>>;
  page?: Maybe<Page>;
};

export type CreateCampaignInput = {
  client: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  storeContext: Scalars['String'];
  itemContext: Scalars['String'];
  name: Scalars['String'];
  storeGroupName: Scalars['String'];
  itemGroupName: Scalars['String'];
  objective: Objective;
  startDate: Scalars['AWSDate'];
  endDate?: Maybe<Scalars['AWSDate']>;
  notes?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  create?: Maybe<Campaign>;
  update?: Maybe<Campaign>;
  archive?: Maybe<Campaign>;
  deleteCampaign?: Maybe<Campaign>;
};


export type MutationCreateArgs = {
  input: CreateCampaignInput;
  filters: CampaignFilterInput;
};


export type MutationUpdateArgs = {
  id: Scalars['ID'];
  input: CreateCampaignInput;
  filters: CampaignFilterInput;
};


export type MutationArchiveArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID'];
};

export enum Objective {
  Audit = 'audit',
  PricingCompliance = 'pricingCompliance',
  Placement = 'placement',
  NewProductIntro = 'newProductIntro',
  InStoreDemo = 'inStoreDemo',
  InStorePromotion = 'inStorePromotion'
}

export type Page = {
  __typename?: 'Page';
  totalItems: Scalars['Int'];
  totalPages: Scalars['Int'];
};

export type PageableInput = {
  page: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortedBy?: Maybe<Scalars['String']>;
  sortDirection?: Maybe<SortDirection>;
  search?: Maybe<Scalars['String']>;
  searchBy?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Query = {
  __typename?: 'Query';
  retrieve?: Maybe<Campaign>;
  list?: Maybe<CampaignList>;
  whiteListedClients: Array<Scalars['String']>;
};


export type QueryRetrieveArgs = {
  id: Scalars['ID'];
};


export type QueryListArgs = {
  client: Scalars['String'];
  brand?: Maybe<Scalars['String']>;
  status?: Maybe<Array<Maybe<Status>>>;
  pageable?: Maybe<PageableInput>;
};

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum Status {
  Active = 'active',
  Inactive = 'inactive',
  Archived = 'archived'
}

export type ListCampaignsQueryVariables = Exact<{
  clientID: Scalars['String'];
  status?: Maybe<Array<Status> | Status>;
  brand?: Maybe<Scalars['String']>;
  pageable?: Maybe<PageableInput>;
}>;


export type ListCampaignsQuery = (
  { __typename?: 'Query' }
  & { list?: Maybe<(
    { __typename?: 'CampaignList' }
    & { data: Array<Maybe<(
      { __typename?: 'Campaign' }
      & Pick<Campaign, 'id' | 'name' | 'objective' | 'startDate' | 'endDate' | 'status'>
      & { storeFilters?: Maybe<(
        { __typename?: 'CampaignFilter' }
        & Pick<CampaignFilter, 'stores' | 'accounts' | 'states'>
        & { counts?: Maybe<(
          { __typename?: 'CampaignFilterCount' }
          & Pick<CampaignFilterCount, 'stores' | 'accounts'>
        )> }
      )>, itemFilters?: Maybe<(
        { __typename?: 'CampaignFilter' }
        & Pick<CampaignFilter, 'items'>
        & { counts?: Maybe<(
          { __typename?: 'CampaignFilterCount' }
          & Pick<CampaignFilterCount, 'items'>
        )> }
      )> }
    )>>, page?: Maybe<(
      { __typename?: 'Page' }
      & Pick<Page, 'totalItems' | 'totalPages'>
    )> }
  )> }
);

export type GetCampaignQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCampaignQuery = (
  { __typename?: 'Query' }
  & { retrieve?: Maybe<(
    { __typename?: 'Campaign' }
    & Pick<Campaign, 'id' | 'name' | 'storeGroupName' | 'itemGroupName' | 'objective' | 'startDate' | 'endDate' | 'notes'>
    & { storeFilters?: Maybe<(
      { __typename?: 'CampaignFilter' }
      & Pick<CampaignFilter, 'accounts' | 'states' | 'stores'>
    )>, itemFilters?: Maybe<(
      { __typename?: 'CampaignFilter' }
      & Pick<CampaignFilter, 'items'>
    )> }
  )> }
);

export type WhiteListedClientsQueryVariables = Exact<{ [key: string]: never; }>;


export type WhiteListedClientsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'whiteListedClients'>
);

export type CreateCampaignMutationVariables = Exact<{
  input: CreateCampaignInput;
  filters: CampaignFilterInput;
}>;


export type CreateCampaignMutation = (
  { __typename?: 'Mutation' }
  & { create?: Maybe<(
    { __typename?: 'Campaign' }
    & Pick<Campaign, 'id' | 'brand' | 'name' | 'objective' | 'startDate' | 'endDate' | 'status'>
    & { storeFilters?: Maybe<(
      { __typename?: 'CampaignFilter' }
      & Pick<CampaignFilter, 'accounts' | 'states' | 'stores'>
      & { counts?: Maybe<(
        { __typename?: 'CampaignFilterCount' }
        & Pick<CampaignFilterCount, 'stores' | 'accounts'>
      )> }
    )>, itemFilters?: Maybe<(
      { __typename?: 'CampaignFilter' }
      & Pick<CampaignFilter, 'items'>
      & { counts?: Maybe<(
        { __typename?: 'CampaignFilterCount' }
        & Pick<CampaignFilterCount, 'items'>
      )> }
    )> }
  )> }
);

export type UpdateCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
  input: CreateCampaignInput;
  filters: CampaignFilterInput;
}>;


export type UpdateCampaignMutation = (
  { __typename?: 'Mutation' }
  & { update?: Maybe<(
    { __typename?: 'Campaign' }
    & Pick<Campaign, 'id' | 'name' | 'storeGroupName' | 'itemGroupName' | 'objective' | 'startDate' | 'endDate' | 'notes' | 'status'>
    & { storeFilters?: Maybe<(
      { __typename?: 'CampaignFilter' }
      & Pick<CampaignFilter, 'accounts' | 'stores' | 'states'>
      & { counts?: Maybe<(
        { __typename?: 'CampaignFilterCount' }
        & Pick<CampaignFilterCount, 'stores' | 'accounts'>
      )> }
    )>, itemFilters?: Maybe<(
      { __typename?: 'CampaignFilter' }
      & Pick<CampaignFilter, 'items'>
      & { counts?: Maybe<(
        { __typename?: 'CampaignFilterCount' }
        & Pick<CampaignFilterCount, 'items'>
      )> }
    )> }
  )> }
);

export type ArchiveCampaignMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ArchiveCampaignMutation = (
  { __typename?: 'Mutation' }
  & { archive?: Maybe<(
    { __typename?: 'Campaign' }
    & Pick<Campaign, 'id' | 'name' | 'objective' | 'startDate' | 'endDate' | 'status'>
    & { storeFilters?: Maybe<(
      { __typename?: 'CampaignFilter' }
      & Pick<CampaignFilter, 'stores' | 'accounts' | 'states'>
      & { counts?: Maybe<(
        { __typename?: 'CampaignFilterCount' }
        & Pick<CampaignFilterCount, 'stores' | 'accounts'>
      )> }
    )>, itemFilters?: Maybe<(
      { __typename?: 'CampaignFilter' }
      & Pick<CampaignFilter, 'items'>
      & { counts?: Maybe<(
        { __typename?: 'CampaignFilterCount' }
        & Pick<CampaignFilterCount, 'items'>
      )> }
    )> }
  )> }
);


export const ListCampaignsDocument = gql`
    query ListCampaigns($clientID: String!, $status: [Status!], $brand: String, $pageable: PageableInput) {
  list(client: $clientID, status: $status, brand: $brand, pageable: $pageable) {
    data {
      id
      name
      objective
      startDate
      endDate
      status
      storeFilters {
        counts {
          stores
          accounts
        }
        stores
        accounts
        states
      }
      itemFilters {
        counts {
          items
        }
        items
      }
    }
    page {
      totalItems
      totalPages
    }
  }
}
    `;
export type ListCampaignsQueryResult = Apollo.QueryResult<ListCampaignsQuery, ListCampaignsQueryVariables>;
export const GetCampaignDocument = gql`
    query GetCampaign($id: ID!) {
  retrieve(id: $id) {
    id
    name
    storeGroupName
    itemGroupName
    objective
    startDate
    endDate
    notes
    storeFilters {
      accounts
      states
      stores
    }
    itemFilters {
      items
    }
  }
}
    `;
export type GetCampaignQueryResult = Apollo.QueryResult<GetCampaignQuery, GetCampaignQueryVariables>;
export const WhiteListedClientsDocument = gql`
    query WhiteListedClients {
  whiteListedClients
}
    `;
export type WhiteListedClientsQueryResult = Apollo.QueryResult<WhiteListedClientsQuery, WhiteListedClientsQueryVariables>;
export const CreateCampaignDocument = gql`
    mutation CreateCampaign($input: CreateCampaignInput!, $filters: CampaignFilterInput!) {
  create(input: $input, filters: $filters) {
    id
    brand
    name
    objective
    startDate
    endDate
    status
    storeFilters {
      counts {
        stores
        accounts
      }
      accounts
      states
      stores
    }
    itemFilters {
      counts {
        items
      }
      items
    }
  }
}
    `;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const UpdateCampaignDocument = gql`
    mutation UpdateCampaign($id: ID!, $input: CreateCampaignInput!, $filters: CampaignFilterInput!) {
  update(id: $id, input: $input, filters: $filters) {
    id
    name
    storeGroupName
    itemGroupName
    objective
    startDate
    endDate
    notes
    status
    storeFilters {
      counts {
        stores
        accounts
      }
      accounts
      stores
      states
    }
    itemFilters {
      counts {
        items
      }
      items
    }
  }
}
    `;
export type UpdateCampaignMutationFn = Apollo.MutationFunction<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export type UpdateCampaignMutationResult = Apollo.MutationResult<UpdateCampaignMutation>;
export type UpdateCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignMutation, UpdateCampaignMutationVariables>;
export const ArchiveCampaignDocument = gql`
    mutation ArchiveCampaign($id: ID!) {
  archive(id: $id) {
    id
    name
    objective
    startDate
    endDate
    status
    storeFilters {
      counts {
        stores
        accounts
      }
      stores
      accounts
      states
    }
    itemFilters {
      counts {
        items
      }
      items
    }
  }
}
    `;
export type ArchiveCampaignMutationFn = Apollo.MutationFunction<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>;
export type ArchiveCampaignMutationResult = Apollo.MutationResult<ArchiveCampaignMutation>;
export type ArchiveCampaignMutationOptions = Apollo.BaseMutationOptions<ArchiveCampaignMutation, ArchiveCampaignMutationVariables>;